<template>
  <div>
    <basic-info :value="application"/>
    <charge-details
        :value="application"
        :cost-unit-price-only="isTenant"
    />
    <application-progress :value="application.applicationProgress"/>
    <vg-collapse-panel
        v-if="!isTenant"
        title="申请人员"
    >
      <applicant-list :value="application.applicantForms"/>
    </vg-collapse-panel>
    <vg-button-group-fixed>
      <vg-button
          v-if="application.applicationSituation?.passCardStatus === 'REJECTED'"
          class="primary"
          @click="reapply"
      >
        再次申请
      </vg-button>
      <vg-button
          v-if="application.applicationSituation?.passCardStatus === 'PENDING_PAYMENT'"
          class="primary"
          @click="continueToPay"
      >
        继续支付
      </vg-button>
    </vg-button-group-fixed>
  </div>
</template>

<script>
import {client,} from "@/libraries/http";
import BasicInfo from "./BasicInfo";
import ChargeDetails from "./ChargeDetails";
import ApplicationProgress from "./ApplicationProgress";
import ApplicantList from "./ApplicantList";
import VgButtonGroupFixed from "@/components/Commons/VgButtonGroupFixed.vue";
import VgButton from "@/components/Commons/VgButton.vue";
import VgCollapsePanel from "@/components/Commons/VgCollapsePanel.vue";
import {mapState} from "pinia";
import useAuthnStore from "@/store/authn";

export default {
  name: "DigitalPassApplication",
  components: {
    VgCollapsePanel,
    VgButton,
    VgButtonGroupFixed,
    ApplicantList,
    ApplicationProgress,
    ChargeDetails,
    BasicInfo,
  },
  props: {},
  data() {
    return {
      application: {},
    };
  },
  created() {
    this.getList();
  },
  computed: {
    ...mapState(useAuthnStore, ['isTenant']),
    applicationSituationId() {
      return this.$route.params.applicationSituationId
    }
  },
  methods: {
    getList() {
      client.get(`/api/h5/digital-passes/applications/${this.applicationSituationId}`).then(rsp => {
        this.application = rsp.data;
      })
    },
    reapply() {
      //点击再次申请 跳转申请页面 传applicationSituationId
      this.$router.push({
        path: `/digital-passes/applications/${this.applicationSituationId}/form`,
      });
    },
    refresh(application) {
      if (application?.orderCode) {
        return Promise.resolve(application)
      }

      return client.get(`/api/h5/digital-passes/applications/${this.applicationSituationId}`)
          .then(rsp => {
            this.application = rsp.data;
            if (!this.application?.orderCode) {
              this.$toast.fail("获取工本费失败，请联系相关营运人员")
              return Promise.reject()
            }
            return this.application
          })
    },
    continueToPay() {
      this.refresh(this.application)
          .then(() => {
            this.$router.push({
              path: '/scanVerify/chargePay', query: {
                orderNo: this.application.orderCode,
                orderAmount: this.application.paymentAmount
              }
            });
          })
    }
  },
};
</script>

<style scoped>
</style>
